import React from 'react';
import {
    BrowserRouter,
    Route,
    Switch
} from 'react-router-dom';
// import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

// App components
import Header from './Header';
import Navigation from './Navigation';
import Landing from './Landing';
import Services from './Services';
import ContactMe from './ContactMe';
import Slider from './Slider';
import NotFound from './NotFound';
import Footer from './Footer';
import Gallery from './Gallery';

const Dashboard = () => (
    <BrowserRouter>
        <main className="content-wrapper">
            <Slider />
            <Header />
            <Navigation />        
            <Switch>
                <Route exact path="/" component={Landing} />
                <Route path="/gallery" component={Gallery} />
                <Route path="/services" component={Services} />
                <Route path="/contact" component={ContactMe} />
                <Route component={NotFound} />
            </Switch>
            <Footer />
        </main>
    </BrowserRouter>
);
export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/Dashboard.js